// eslint-disable-next-line
import * as React from 'react';
import './BpiViewNavBar.css';
import logo from '../../../images/st_logo.svg';

type Props = {
}

type State = {

}

// ------------------------------------------------------------------------------------------------
// component

class BpiViewNavBar extends React.Component<Props, State> {

    // --------------------------------------------------------------------------------------------
    // render

    public render() {
        return <div className='bpi-view-navbar'>

            <div className='bpi-view-navbar-header'>
                <a href={"https://steelandtube.co.nz/"}>
                    <img className='st_logo' src={logo} alt="Steel&Tube"></img>
                </a>
            </div>

            <div className='bpi-view-navbar-footer'>

                <div className='primaryButton'>
                    <a href="https://portal.steelandtube.co.nz/profile/login">
                        WEBSHOP
                    </a>
                </div>

                <div className='secondaryButton'>
                    <a href="/">
                        OPEN ACCOUNT
                    </a>
                </div>

            </div>

        </div>
    }
};



export default BpiViewNavBar;